import globalEventBus, {GLOBAL_EVENTS} from 'shared/globalEventBus';

/**
 * Moves the header's activity counter and nothing else - no refetch, no notification, no sound.
 *
 * Activity runs an order of magnitude above alerts: one post to a community reaches its whole
 * subscriber list at once, and every one of those tabs refetching its counter off the back of it
 * is the herd this avoids. The increment is the whole point, and the next counters refresh
 * reconciles it with the server.
 *
 * The feed page registers its own listener, which runs ahead of the default ones and stops the
 * chain - it is showing the activity itself, and moves the read mark by doing so.
 */
export const onNewSiteActivity = async (e) => {
    /**
     * @param {LiveEventNewSiteActivity} e
     */
    globalEventBus.emit(GLOBAL_EVENTS.ACTIVITY_UNREAD_COUNT_INCREASED);
};
